import { compose, withProps } from 'recompose';

import { Endpoints } from '../../../lib/LeanLinkService';
import withPagination from '../../PaginatedItems/withPagination';
import withMunicipalities from '../../../containers/withMunicipalities';
import RichSelect from '../RichSelect/RichSelect';
import { withTranslation } from 'react-i18next';

export default compose(
  withTranslation(),
  withProps(({ t }) => ({
    placeholder: t('Välj kommun'),
    url: Endpoints.municipalities(),
    filterOption: null,
  })),
  withPagination(),
  withProps(({ ids }) => ({
    municipalitiesIds: ids,
  })),
  withMunicipalities,
  withProps(({ municipalities }) => ({
    options: municipalities ? municipalities
      .map(({ id, name }) => ({ value: id, label: name })) : [],
  })),
)(RichSelect);
